import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsComponent } from './fields.component';
import { FormsModule } from '@angular/forms';
import { FieldComponent } from './field/field.component';
import { UploadFileModule } from 'projects/core/src/common/upload-file/upload-file.module';
import { TakephotoModule } from 'projects/core/src/common/takephoto/takephoto.module';
import { FieldSettingComponent } from './field-setting/field-setting.component';



@NgModule({
  declarations: [
    FieldsComponent,
    FieldComponent,
    FieldSettingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UploadFileModule,
    TakephotoModule
  ],
  exports:[
    FieldsComponent,
    FieldComponent,
    FieldSettingComponent
  ]
})
export class FieldsModule { }
